import React from "react"
// import Fade from 'react-reveal/Fade';
import Shake from 'react-reveal/Shake';
import Flash from 'react-reveal/Flash';
import { Link } from "gatsby"
import profile from "../images/hero1.svg"
import Shape1 from "../images/shape-1.png"
import Shape2 from "../images/shape-2.png"
import Shape3 from "../images/shape-3.png"
import Shape4 from "../images/shape-4.png"
import Shape5 from "../images/shape-5.png"
import Shape6 from "../images/shape-6.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faGithub,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons"

export const Hero = () => {
  return (
    <>
    
      <div
        id="parallax"
        className="header-content d-flex align-items-center h-screen"
      >
        <div className="header-shape shape-one layer" data-depth="0.10">
          <img src={Shape1} alt="Shape" />
        </div>
        <div className="header-shape shape-tow layer" data-depth="0.30">
          <img src={Shape2} alt="Shape" />
        </div>
        <div className="header-shape shape-three layer" data-depth="0.40">
          <img src={Shape3} alt="Shape" />
        </div>
        <div className="header-shape shape-fore layer" data-depth="0.60">
          <img src={Shape4} alt="Shape" />
        </div>
        <div className="header-shape shape-five layer" data-depth="0.20">
          <img src={Shape1} alt="Shape" />
        </div>
        <div className="header-shape shape-six layer" data-depth="0.15">
          <img src={Shape4} alt="Shape" />
        </div>
        <div className="header-shape shape-seven layer" data-depth="0.50">
          <img src={Shape5} alt="Shape" />
        </div>
        <div className="header-shape shape-eight layer" data-depth="0.40">
          <img src={Shape3} alt="Shape" />
        </div>
        <div className="header-shape shape-nine layer" data-depth="0.20">
          <img src={Shape1} alt="Shape" />
        </div>
        <div className="header-shape shape-ten layer" data-depth="0.30">
          <img src={Shape6} alt="Shape" />
        </div>
        
        <div className="container">    
      
          <div className="row align-items-center">
            <div className="col-xl-5 col-lg-6 bg-transparent">
              <div className="header-content-right typewriter bg-transparent">
                <h4 className="sub-title bg-transparent">Hello, I’m</h4>
                <h1 className="title bg-transparent">Ganesh Pandey</h1>
                <Flash>
                <p className="bg-transparent">Software Engineer</p> </Flash>
                <Shake> <h5 className="sub-title bg-transparent -mt-8">Nice to meet you.</h5></Shake>
               
               
                <a className="main-btn hover:no-underline" href="#projects">
                  View my Work
                </a>
              </div>
            </div>
            <div id="mySidenav" className="_sidenav">
            <a className="_Link" href="/#about" id="about1">
            About
            </a>
            <a href="/#projects" className="_Link" id="projects1">
            Projects
            </a>
            <a href="/#contact" className="_Link" id="contact1">
            Contact
            </a>
       
      </div> 
            <div className="col-lg-6 offset-xl-1">
              <div className="header-image d-none d-lg-block">
                <img src={profile} width="1126px" height="1942px" alt="hero" />
              </div>
            </div>
          </div>
        </div>
        <div className="header-social bg-transparent">
          <div className="container bg-transparent">
            <div className="row">
              <div className="col-lg-12">
                <div className="header-social-icon bg-transparent">
                  <ul>
                    <li>
                      <Link to="https://github.com/GaneshPandey-GP" target="_blank">
                        
                        <FontAwesomeIcon
                          icon={faGithub}
                          size="lg"
                          role="button"
                          aria-label="Github"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.linkedin.com/in/ganesh-pandey-1426b4171/" target="_blank">
                        
                        <FontAwesomeIcon
                          icon={faLinkedin}
                          size="lg"
                          role="button"
                          aria-label="LinkedIn"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://twitter.com/GaneshpandeyG" target="_blank">
                        <FontAwesomeIcon
                          icon={faTwitter}
                          size="lg"
                          role="button"
                          aria-label="Facebook"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.instagram.com/ganesh.pandey.179/" target="_blank">
                        <FontAwesomeIcon
                          icon={faInstagram}
                          size="lg"
                          role="button"
                          aria-label="Facebook"
                        />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
